var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnlineStatusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96415 3.19294C5.29851 3.19294 4.66013 3.45736 4.18945 3.92804C3.71877 4.39872 3.45435 5.0371 3.45435 5.70274V11.0361C3.45435 11.7017 3.71877 12.3401 4.18945 12.8108C4.66013 13.2815 5.29851 13.5459 5.96415 13.5459H11.2975C11.9631 13.5459 12.6015 13.2815 13.0722 12.8108C13.5429 12.3401 13.8073 11.7017 13.8073 11.0361M9.72886 3.19294H11.4543H13.1798C13.353 3.19294 13.5099 3.26321 13.6234 3.37678M13.6234 3.37678C13.7411 3.49442 13.8073 3.65399 13.8073 3.82039V7.27137M13.6234 3.37678L13.1798 3.82039L11.1406 5.8596L9.1014 7.89882",
    stroke: "#2AB75A",
    strokeWidth: 1.41176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25831 3.66354H10.9838H12.7093C12.8825 3.66354 13.0393 3.73381 13.1529 3.84738M13.1529 3.84738C13.2706 3.96503 13.3367 4.12459 13.3367 4.29099V7.74197M13.1529 3.84738L12.7093 4.29099L10.6701 6.33021L8.63086 8.36942",
    stroke: "#2AB75A",
    strokeWidth: 2.35294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineStatusIcon);
export default __webpack_public_path__ + "static/media/online_status_icon.1d21f4a5bf5a48c7155e335e7d04d75e.svg";
export { ForwardRef as ReactComponent };